import { BreedDto } from 'src/dto/breed.dto'
import { API } from '../config'
import { AxiosResponse } from 'axios'

const BASE_URL = '/entity/Raca'

export class BreedService {
  public async getBreedList(): Promise<AxiosResponse<BreedDto[]>> {
    return await API.get(`${BASE_URL}`)
  }
}
